<template>
    <div class="tabpanel_inner">
        <component :is="useComponent" :component_data="tab"></component>
    </div>
</template>

<script>
import text_right from './Contents/text_right.vue'
import text_left from './Contents/text_left.vue'
import text_right_vid from './Contents/text_right_vid.vue'
import text_right_vid_no_thumb from './Contents/text_right_vid_no_thumb.vue'
import text_left_vid from './Contents/text_left_vid.vue'
import text_left_vid_no_thumb from './Contents/text_left_vid_no_thumb.vue'
import text_right_video_left from './Contents/text_right_video_left.vue'

export default {
    props: ['component_data'],
    data(){
        return {
            useComponent: 'text_right',
            tab: {}
        }
    },
    mounted(){
        this.tab = this.component_data
        this.useComponent = this.tab.component
    },
    components: {
        text_right_vid,
        text_right_vid_no_thumb,
        text_left_vid, 
        text_left_vid_no_thumb, 
        text_right,
        text_left,
        text_right_video_left
    }

}
</script>

<style>

    /* Base elements */
    
        .tab_wrapper {
            position: relative;
        }

        .tab_wrapper::before {
            content: '';
            height: 100%;
            width: 91.6666%;
            position: absolute;
            background-color: #FAF9F7;        
        }
        .tabpanel_inner {
            width: 100vw;
            max-width: 1920px;
        }
        .tab_contents {
            position: relative;
            margin: 0 auto;
            display: flex;
        }
        .tab_visual {
            position: relative;
            z-index: 0;
            margin: 4em 0;
        }
        .tab_photo-small,
        .tab_video {
            bottom: -6em;
            z-index: 1;
            display: flex;
        }

        .tab_photo-big {
            height: 36.55vw;
            width: 33.33vw;   
            position: relative;        
        }
        .tab_photo-big::before
        {
            position: absolute;
            height: 15.49vw;
            width: 25vw;        
            bottom: -3em;
            z-index: -1;
        }
        .tab_video img,
        .tab_photo-big img {
            height: 100%;
            width: 100%;
            object-fit: cover;
        }

        .tab_photo-big--sidenote {
            font-size: 1.5em;
            bottom: 0;
            max-width: 100%;
            display: block;
            position: absolute;
            z-index: 10;
            padding: .8em;
            color: #fce5df;
            text-shadow: 0 0 4px black;
        }

        .tab_caption {
            display: flex;
            flex-direction: column;
            justify-content: center;
            padding: 3em 0;
        }
        .tab_caption header {
            display: flex;
            align-items: center;
            margin-bottom: 4.5em;
            color: #E41429;
        }
        .tab_caption header h2 {
            line-height: 1.41em;
            font-size: 3.8em;
            font-weight: 700;
            margin: 0 0 0 1.25em;
            padding-right: 0.625em;
            font-family: 'Uni Neue', sans-serif;
        }
        .tab_texts {
            padding: 0 3em;
        }
        .tab_caption p {
            font-size: 2em;
            line-height: 1.9em;
            font-family: 'Lato', sans-serif;
        }
        .tab_icon {
            margin: 0;
        }
        .tab_icon svg * {
            color: white;
        }
        .tab_icon svg.noReverseColor *  {
            color: #E41429;
        }
    
        .tab_icon svg {
            width: 10em;
            height: 10em;
            border-radius: 8px;            
            background-color: currentColor;
            margin: 0;
        }

        .tab_icon.customSize svg {
            width: 100%;
            height: 100%;
        }
    
        .tab_wrapper img {
            max-width: 100%;
        }

        .tab_wrapper video {
            max-width: 100%;
        }


        @media(max-width: 992px){
            .tabs_wrapper .tabpanel_inner {
                width: 100vw;
                height: 100%;
            }
            .tabbed-common .tabs_wrapper .tabpanel_inner {
                width: calc(100vw - 80px);
                height: 100%;
            }
            .tab_contents {
                flex-direction: column;
            }
            .tab_visual {
                display: flex;
                justify-content: center;
            }
            .tab_photo-big {
                margin: 0;
                height: 54.825vw;
                width: 49.995vw;   
            }
            .tab_wrapper { 
                height: 100%;   
            }
            .tab_wrapper::before {
                width: 100%;  
                height: 100%;   
            }
        }
        @media(max-width: 576px){
            .tab_contents {
                width: 95%;
            }
            .tab_icon {
                display: none;
            }
            .tab_caption header h2 {
                margin-left: .8em;
            }
        }
</style>